import { getLocaleMonthNames } from '@angular/common';
import { Injectable } from '@angular/core';
import { child, DatabaseReference, DataSnapshot, equalTo, get, getDatabase, orderByChild, push, query, ref, remove, update } from 'firebase/database';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import CONFIG from 'src/app/app.config';
import { createUser, User } from 'src/app/d3/models/user';
import { FirebaseService } from 'src/app/d3/services/firebase.service';

@Injectable({
  providedIn: 'root'
})
export class UserdataService {
  private fb_session_name = CONFIG.APPLICATION.AUTH.SESSION_NAME;
  private version = CONFIG.RELEASE.VERSION;
  private userRoot = CONFIG.APPLICATION.AUTH.FB_USER_ROOT_PATH;
  private pplan = CONFIG.APPLICATION.ADDITIONAL.P_PLAN;
  private dbRef: DatabaseReference;
  private promise?: Promise<Object>;
  localData$ = new BehaviorSubject<User | null>(this.retrieveLocalData() || null);
  userDetails$ = new BehaviorSubject<User | null>(null);
  
  
  constructor(private fbService : FirebaseService) { 
    // this.dbRef = this.fbService.db(`${this.version}/${this.userRoot}`);
    this.dbRef = ref(getDatabase(), `${this.version}/${this.userRoot}`);
    const that = this;
    this.fbService.onAuthStateChange().subscribe(async (user) => {
      if(!! user) {
        const uId = user.uid;
        const accessToken = await user.getIdToken();
        const userQuery = await query(that.dbRef, orderByChild('userId'), equalTo(uId)); //this.dbRef.orderByChild('userId').equalTo(uId);
        //Listen for changes on this record then update the details
        // userRef.on('value', async function(realtimeUpdates: any) {
        await get(userQuery).then((realtimeUpdates: DataSnapshot) => {
          const userData = realtimeUpdates.val();
          if(! userData) {
            // that.saveUserData()
            return;
          }
          that.userDetails$.next({
            ...userData[uId],
            accessToken
          });
          console.log('Updates recieved for user=', uId);
        })
      }
    });

    this.userDetails$.subscribe((data: any) => {
      this.saveLocalData(data);
    });
  }

  getUserData(uId: string): Promise<any> {
    var that = this;
    this.promise = new Promise(function(resolve, reject) { 
      // that.dbRef.child(uId).on("value", (snapshot: any) => {
      get(that.dbRef).then((snapshot: DataSnapshot) => {
        if(! snapshot.exists()) {
          reject(`No snapshot data found for user ${uId}`);
        }
        
        let udata = snapshot.val();
        if(! udata) {
          reject(`Failed to fetch user data for:${uId}`);
        }

        resolve(udata);
      });
    });

    return this.promise;
  }

  removeUserData(uId: string): Promise<any> {
    var that = this;
    return this.promise = new Promise(function(resolve, reject) {
      // that.dbRef.child(uId).remove().then((onComplete: any)=> {
      const queryByChild = ref(getDatabase(), uId);
      remove(queryByChild).then((onComplete: any) => {
        console.log(`Removing user data complete`);
        resolve(onComplete)
      }, (onError: Error)=> {
        console.error(`Failed to remove user data due to error ${onError}`);
        reject(onError);
      })
    })
  }

  protected async saveUserData(user: User, uId?: String) {
    // const userRef = this.dbRef.orderByChild('userId').equalTo(uId.valueOf());
    // await this.dbRef
    //     .child((uId as any).valueOf())
    //     .update(user)
    //     .then(() => {})
    //     .catch((err: Error) => this.dbRef.push(user));
    const childQuery = child(this.dbRef, (uId as any).valueOf());
    await update(childQuery, user).then(() => {})
      .catch((err: any) => push(this.dbRef, user));
  }

  //Update user data with additional details
  setTraversedPaths(uId : String, paths: any[]) : Promise<any> {
    if(! this.localData$.getValue()) {
      // this.localData$.next();
      this.sanitizeUserData();
    }
    
    return this.updateData({'paths': paths});
  }

  retrieveLocalData(): User | undefined {
    const lstorage = localStorage.getItem(this.fb_session_name); 
    if(!! lstorage) {
      return JSON.parse(lstorage);
    } else {
      return undefined;
    }
  }

  saveLocalData(sessionData: User | null) {
    if(sessionData == null) return;
    const current = localStorage.getItem(this.fb_session_name);
    let data: User;
    //No data in local storage
    if(!current && current == null) {
      data = sessionData;
    } else {
      const parseCurrent = JSON.parse(current);
      // If record already exists only update a portion of it
      if(parseCurrent != null && parseCurrent.userId == sessionData.userId) {
        data =  {
          ...parseCurrent,
          ...{
            displayName: sessionData.displayName,
            token: sessionData.token,
            refreshToken: sessionData.refreshToken,
            emailVerified: sessionData.emailVerified,
            photoUrl: sessionData.photoUrl,
            providerId: sessionData.provider,
            subscription: sessionData.subscription || null
          }
        };
      } else {
        data = sessionData;
      }
    }
    localStorage.setItem(this.fb_session_name, JSON.stringify(data || null));
    this.localData$.next(data);
  }
  
  // Sync to cloud, then what ever comes back updates local data
  // ---> cloud ---> updates listern ==>>> localstorage
  syncUserData(userData: User) {
    this.saveUserData(userData, userData.userId);
    // .then((data)=> {});
  }

  updateData(obj : any) {
    let user = this.localData$.getValue();
    if(!user) return Promise.reject(false);
    for(var key in obj) {
      (user as any)[key] = obj[key];
    }
    return this.saveUserData(user, user.userId);
  }

  sanitizeUserData() {
    let params = ["refreshToken", "token"]; 

    for(var key in params) {
      if(!! (this.localData$ as any)[key]) {
        (this.localData$ as any)[key] = undefined;
      }
    }
  }

  async logOutSessions() {
    await this.fbService.signOut();
    this.userDetails$.next(null);
    this.removeLocalData();
  }

  removeLocalData() {
    localStorage.removeItem(this.fb_session_name);
    this.localData$.next(null);
  }
}
